export const GetArea = (area: AreaKey): { ok: boolean; area?: Area } => {
    const r = Areas.find((a) => a.key === area);
    return r ? { ok: true, area: r } : { ok: false };
};

export type AreaKey = 'kanto' | 'chubu' | 'kansai' | 'others';

export interface Prefecture {
    code: string;
    name: string;
    area: string;
}
export type Area = {
    key: AreaKey;
    id: number;
    name: string;
    prefectures: Prefecture[];
};

export const GetPrefecture = (code: string): string => {
    return Prefectures.find((p) => p.code === code)?.name;
};
export const GetPrefectures = (area: string): Prefecture[] => {
    return Prefectures.filter((p) => p.area === area);
};

export const Prefectures: Prefecture[] = [
    { code: '01', name: '北海道', area: 'others' },
    { code: '02', name: '青森県', area: 'others' },
    { code: '03', name: '岩手県', area: 'others' },
    { code: '04', name: '宮城県', area: 'others' },
    { code: '05', name: '秋田県', area: 'others' },
    { code: '06', name: '山形県', area: 'others' },
    { code: '07', name: '福島県', area: 'others' },
    { code: '08', name: '茨城県', area: 'kanto' },
    { code: '09', name: '栃木県', area: 'kanto' },
    { code: '10', name: '群馬県', area: 'kanto' },
    { code: '11', name: '埼玉県', area: 'kanto' },
    { code: '12', name: '千葉県', area: 'kanto' },
    { code: '13', name: '東京都', area: 'kanto' },
    { code: '14', name: '神奈川県', area: 'kanto' },
    { code: '15', name: '新潟県', area: 'others' },
    { code: '16', name: '富山県', area: 'others' },
    { code: '17', name: '石川県', area: 'others' },
    { code: '18', name: '福井県', area: 'others' },
    { code: '19', name: '山梨県', area: 'kanto' },
    { code: '20', name: '長野県', area: 'kanto' },
    { code: '21', name: '岐阜県', area: 'chubu' },
    { code: '22', name: '静岡県', area: 'chubu' },
    { code: '23', name: '愛知県', area: 'chubu' },
    { code: '24', name: '三重県', area: 'chubu' },
    { code: '25', name: '滋賀県', area: 'kansai' },
    { code: '26', name: '京都府', area: 'kansai' },
    { code: '27', name: '大阪府', area: 'kansai' },
    { code: '28', name: '兵庫県', area: 'kansai' },
    { code: '29', name: '奈良県', area: 'kansai' },
    { code: '30', name: '和歌山県', area: 'kansai' },
    { code: '31', name: '鳥取県', area: 'others' },
    { code: '32', name: '島根県', area: 'others' },
    { code: '33', name: '岡山県', area: 'others' },
    { code: '34', name: '広島県', area: 'others' },
    { code: '35', name: '山口県', area: 'others' },
    { code: '36', name: '徳島県', area: 'others' },
    { code: '37', name: '香川県', area: 'others' },
    { code: '38', name: '愛媛県', area: 'others' },
    { code: '39', name: '高知県', area: 'others' },
    { code: '40', name: '福岡県', area: 'others' },
    { code: '41', name: '佐賀県', area: 'others' },
    { code: '42', name: '長崎県', area: 'others' },
    { code: '43', name: '熊本県', area: 'others' },
    { code: '44', name: '大分県', area: 'others' },
    { code: '45', name: '宮崎県', area: 'others' },
    { code: '46', name: '鹿児島県', area: 'others' },
    { code: '47', name: '沖縄県', area: 'others' },
];

export const Areas: Area[] = [
    {
        key: 'kanto',
        id: 1,
        name: '関東エリア',
        prefectures: Prefectures.filter((p) => p.area === 'kanto'),
    },
    {
        key: 'chubu',
        id: 2,
        name: '中部エリア',
        prefectures: Prefectures.filter((p) => p.area === 'chubu'),
    },
    {
        key: 'kansai',
        id: 3,
        name: '関西エリア',
        prefectures: Prefectures.filter((p) => p.area === 'kansai'),
    },
    {
        key: 'others',
        id: 9,
        name: 'その他',
        prefectures: Prefectures.filter((p) => p.area === 'others'),
    },
];

export const prefIncludeArea = (pref: string) => {
    const p = Prefectures.find((p) => p.name === pref);
    return p ? p.area : 'others';
};

export const CTA_HIDDEN_PAGES = [
    '/contact',
    '/contact/confirm',
    '/contact/complete',
    '/periodic_mail',
    '/periodic_mail/confirm',
    '/periodic_mail/complete',
];
